module.exports = __webpack_public_path__ + "img/8.4ac55be3.png";